export default "__VITE_ASSET__SXp$ZxHN__"